// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__lUKpK","codedBy":"Footer_codedBy__JYqNE","group":"Footer_group__XNa09"};